import {
    makeStyles,
} from 'app/tss'

const addressDetails = 'addressDetails'
const location = 'location'
const shippingLocation = 'shippingLocation'
const airportDetails = 'airportDetails'
const seaportDetails = 'seaportDetails'
const billingDetails = 'billingDetails'
const serviceCenter = 'serviceCenter'
const bolAwbDetails = 'bolAwbDetails'
const contactDetails = 'contactDetails'
const railportDetails = 'railportDetails'
const serviceCenterMetrics = 'serviceCenterMetrics'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
        },
        gridWrapperAddress: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${location} ${addressDetails} ${addressDetails} ${shippingLocation}"
            " ${contactDetails} ${contactDetails} ${contactDetails} ${contactDetails}"
        `,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        gridWrapperNew: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `"${location} ${addressDetails} ${shippingLocation}"`,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        gridWrapperAddressWithoutShipping: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            "${location} ${addressDetails} ${addressDetails}"     
            " ${contactDetails} ${contactDetails} ${contactDetails}"
            `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        gridWrapperAirport: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${location} ${airportDetails} ${shippingLocation}"
            " ${contactDetails} ${contactDetails} ${contactDetails}"
        `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        gridWrapperSeaport: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${location} ${seaportDetails} ${shippingLocation}"
            " ${contactDetails} ${contactDetails} ${contactDetails}"
        `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        gridWrapperRailport: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${location} ${railportDetails} ${shippingLocation}"
            " ${contactDetails} ${contactDetails} ${contactDetails}"
        `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        gridWrapperBilling: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${location} ${addressDetails} ${addressDetails} ${billingDetails}"
            " ${contactDetails} ${contactDetails} ${contactDetails} ${contactDetails}"
            `,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        gridServiceCenterMetrics: {
            display: 'grid',
            gap: theme.spacing(1.5),
            gridTemplateAreas: `
            "${serviceCenterMetrics} ${serviceCenterMetrics} ${serviceCenterMetrics} ${serviceCenterMetrics}"
            `,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        containerData: {
            gridArea: addressDetails,
        },
        location: {
            gridArea: location,
            display: 'flow-root',
        },
        shippingLocation: {
            gridArea: shippingLocation,
        },
        seaportDetails: {
            gridArea: seaportDetails,
        },
        railportDetails: {
            gridArea: railportDetails,
        },
        airportDetails: {
            gridArea: airportDetails,
        },
        locationType: {
            flexDirection: 'column',
        },
        addressDetails: {
            gridArea: addressDetails,
            minWidth: 290,
            overflow: 'auto !important',
        },
        billingDetails: {
            gridArea: billingDetails,
        },
        serviceCenter: {
            gridArea: serviceCenter,
        },
        bolAwbDetails: {
            gridArea: bolAwbDetails,
        },
        contactDetails: {
            gridArea: contactDetails,
            margin: 0,
            padding: 0,
            overflow: 'auto',
        },
        paymentTerms: {
            flexDirection: 'column',
        },
        serviceCenterMetrics: {
            gridArea: serviceCenterMetrics,
            padding: theme.spacing(1),
        },
    }
})

export default useStyles
